import HttpResponse from "../../../../../utils/http/http.response";

export enum OrderCargoOrderHistoryChangeRideEventType {
  ADD_CARGO_ENTER = "ADD_CARGO_ENTER",
  ADD_CARGO_EXIT = "ADD_CARGO_EXIT",
  CHANGE_HALTING_TIME = "CHANGE_HALTING_TIME",
  CHANGE_POSITION = "CHANGE_POSITION",
  CHANGE_TIME = "CHANGE_TIME",
  CREATE_INNER_RIDE = "CREATE_INNER_RIDE",
  DELETE_NODE = "DELETE_NODE",
  DO_NOTHING = "DO_NOTHING",
  INSERT_NODE_BEFORE = "INSERT_NODE_BEFORE",
  INSERT_NODE_AFTER = "INSERT_NODE_AFTER",
  REMOVE_CARGO_ENTER = "REMOVE_CARGO_ENTER",
  REMOVE_CARGO_EXIT = "REMOVE_CARGO_EXIT",
  SQUASH_INNER_RIDE = "SQUASH_INNER_RIDE",
}

export enum OrderCargoOrderHistoryResponseEventType {
  BIND_PASSENGER = "BIND_PASSENGER",
  CANCEL_ORDER = "CANCEL_ORDER",
  CHANGE_RIDE = "CHANGE_RIDE",
  CHANGE_TARGET_TAXI = "CHANGE_TARGET_TAXI",
  DEALER_APPROVAL = "DEALER_APPROVAL",
  DISPATCH_APPROVAL = "DISPATCH_APPROVAL",
  EXTERNAL_ID_UPDATE = "EXTERNAL_ID_UPDATE",
  INITIALIZE = "INITIALIZE",
  MERGE_ORDERS = "MERGE_ORDERS",
  OPERATIONAL_APPROVAL = "OPERATIONAL_APPROVAL",
  REQUEST_CANCEL_ORDER = "REQUEST_CANCEL_ORDER",
  REVERT_CANCEL_ORDER_REQUEST = "REVERT_CANCEL_ORDER_REQUEST",
  SHUFFLE_MERGE = "SHUFFLE_MERGE_COMMAND",
  FORWARD_ADD = "FORWARD",
  FORWARD_CANCEL = "FORWARD_CANCEL",
  ACCEPTED_CPE_CANDIDATURE = "ACCEPTED_CPE_CANDIDATURE",
  ACCEPTED_CSO_CANDIDATURE = "ACCEPTED_CSO_CANDIDATURE",
  ACCEPTED_DSO_CANDIDATURE = "ACCEPTED_DSO_CANDIDATURE",
}

export enum OrderCargoOrderHistoryResponseBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type OrderCargoOrderHistoryResponseItemSubject = {
  time: string | null;
  haltingTime: number;
  displayName: string;
};

export type OrderCargoOrderHistoryResponseItemAddCargoEnterChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.ADD_CARGO_ENTER;
};

export type OrderCargoOrderHistoryResponseItemAddCargoExitChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.ADD_CARGO_EXIT;
};

export type OrderCargoOrderHistoryResponseItemChangeHaltingTimeChangeRideCommand =
  {
    commandType: OrderCargoOrderHistoryChangeRideEventType.CHANGE_HALTING_TIME;
    haltingTime: number;
  };

export type OrderCargoOrderHistoryResponseItemChangePositionChangeRideCommand =
  {
    commandType: OrderCargoOrderHistoryChangeRideEventType.CHANGE_POSITION;
    displayName: string;
  };

export type OrderCargoOrderHistoryResponseItemChangeTimeChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.CHANGE_TIME;
  time: string | null;
};

export type OrderCargoOrderHistoryResponseItemCreateInnerRideChangeRideCommand =
  {
    commandType: OrderCargoOrderHistoryChangeRideEventType.CREATE_INNER_RIDE;
  };

export type OrderCargoOrderHistoryResponseItemDeleteNodeChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.DELETE_NODE;
};

export type OrderCargoOrderHistoryResponseItemDoNothingChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.DO_NOTHING;
};

export type OrderCargoOrderHistoryResponseItemInsertNodeAfterChangeRideCommand =
  {
    commandType: OrderCargoOrderHistoryChangeRideEventType.INSERT_NODE_AFTER;
    subject: OrderCargoOrderHistoryResponseItemSubject;
  };

export type OrderCargoOrderHistoryResponseItemInsertNodeBeforeChangeRideCommand =
  {
    commandType: OrderCargoOrderHistoryChangeRideEventType.INSERT_NODE_BEFORE;
    subject: OrderCargoOrderHistoryResponseItemSubject;
  };

export type OrderCargoOrderHistoryResponseItemRemoveCargoEnterChangeRideCommand =
  {
    commandType: OrderCargoOrderHistoryChangeRideEventType.REMOVE_CARGO_ENTER;
  };

export type OrderCargoOrderHistoryResponseItemRemoveCargoExitChangeRideCommand =
  {
    commandType: OrderCargoOrderHistoryChangeRideEventType.REMOVE_CARGO_EXIT;
  };

export type OrderCargoOrderHistoryResponseItemSquashInnerRideChangeRideCommand =
  {
    commandType: OrderCargoOrderHistoryChangeRideEventType.SQUASH_INNER_RIDE;
  };

export type OrderCargoOrderHistoryResponseItemChangeRideCommandUpdateRideCommand =

    | OrderCargoOrderHistoryResponseItemAddCargoEnterChangeRideCommand
    | OrderCargoOrderHistoryResponseItemAddCargoExitChangeRideCommand
    | OrderCargoOrderHistoryResponseItemChangeHaltingTimeChangeRideCommand
    | OrderCargoOrderHistoryResponseItemChangePositionChangeRideCommand
    | OrderCargoOrderHistoryResponseItemChangeTimeChangeRideCommand
    | OrderCargoOrderHistoryResponseItemCreateInnerRideChangeRideCommand
    | OrderCargoOrderHistoryResponseItemDeleteNodeChangeRideCommand
    | OrderCargoOrderHistoryResponseItemDoNothingChangeRideCommand
    | OrderCargoOrderHistoryResponseItemInsertNodeAfterChangeRideCommand
    | OrderCargoOrderHistoryResponseItemInsertNodeBeforeChangeRideCommand
    | OrderCargoOrderHistoryResponseItemRemoveCargoEnterChangeRideCommand
    | OrderCargoOrderHistoryResponseItemRemoveCargoExitChangeRideCommand
    | OrderCargoOrderHistoryResponseItemSquashInnerRideChangeRideCommand;

export type OrderCargoOrderHistoryResponseItemInitializeCommandRideWaypoint = {
  time: string | null;
  haltingTime: number;
  displayName: string;
};

export type OrderCargoOrderHistoryResponseDataRideSeqItem =
  | OrderCargoOrderHistoryResponseItemInitializeCommandRideWaypoint
  | OrderCargoOrderHistoryResponseItemInitializeCommandRide;

export type OrderCargoOrderHistoryResponseItemInitializeCommandRide = {
  seq: OrderCargoOrderHistoryResponseDataRideSeqItem[];
};

export type OrderCargoOrderHistoryResponseItemBindPassengerCommand = {
  commandType: OrderCargoOrderHistoryResponseEventType.BIND_PASSENGER;
};

export type OrderCargoOrderHistoryResponseItemCancelOrderCommand = {
  commandType: OrderCargoOrderHistoryResponseEventType.CANCEL_ORDER;
};

export type OrderCargoOrderHistoryResponseItemChangeRideCommand = {
  commandType: OrderCargoOrderHistoryResponseEventType.CHANGE_RIDE;
  updateRideCommandSequence: OrderCargoOrderHistoryResponseItemChangeRideCommandUpdateRideCommand[];
};

export type OrderCargoOrderHistoryResponseItemChangeTargetTaxiCommand = {
  commandType: OrderCargoOrderHistoryResponseEventType.CHANGE_TARGET_TAXI;
};

export type OrderCargoOrderHistoryResponseItemDealerApprovalCommand = {
  commandType: OrderCargoOrderHistoryResponseEventType.DEALER_APPROVAL;
  approvingDealerId: string;
};

export type OrderCargoOrderHistoryResponseItemDispatchApprovalCommand = {
  commandType: OrderCargoOrderHistoryResponseEventType.DISPATCH_APPROVAL;
  approvingDispatcherId: string;
};

export type OrderCargoOrderHistoryResponseItemExternalIdUpdateCommand = {
  commandType: OrderCargoOrderHistoryResponseEventType.EXTERNAL_ID_UPDATE;
  newExternalId: string;
};

export type OrderCargoOrderHistoryResponseItemInitializeCommand = {
  commandType: OrderCargoOrderHistoryResponseEventType.INITIALIZE;
  externalId: string | null;
  ride: OrderCargoOrderHistoryResponseItemInitializeCommandRide;
};

export type OrderCargoOrderHistoryResponseItemOperatorApprovalCommand = {
  commandType: OrderCargoOrderHistoryResponseEventType.OPERATIONAL_APPROVAL;
  approvingOperatorId: string;
};

export type OrderCargoOrderHistoryResponseItemMergeOrderCommand = {
  commandType: OrderCargoOrderHistoryResponseEventType.MERGE_ORDERS;
};

export type OrderCargoOrderHistoryResponseItemRequestCancelOrderCommand = {
  commandType: OrderCargoOrderHistoryResponseEventType.REQUEST_CANCEL_ORDER;
};

export type OrderCargoOrderHistoryResponseItemRevertCancelOrderRequestCommand =
  {
    commandType: OrderCargoOrderHistoryResponseEventType.REVERT_CANCEL_ORDER_REQUEST;
  };

export type OrderCargoOrderHistoryResponseItemShuffleMergeCommandRepresentationTarget =
  {
    humanId: string;
  };

export type OrderCargoOrderHistoryResponseItemShuffleMergeCommandRepresentationSources =
  {
    humanId: string;
  };

export type OrderCargoOrderHistoryResponseItemShuffleMergeCommandRepresentation =
  {
    target: OrderCargoOrderHistoryResponseItemShuffleMergeCommandRepresentationTarget;
    sources: OrderCargoOrderHistoryResponseItemShuffleMergeCommandRepresentationSources[];
  };

export type OrderCargoOrderHistoryResponseItemShuffleMergeCommand = {
  commandType: OrderCargoOrderHistoryResponseEventType.SHUFFLE_MERGE;
  representation: OrderCargoOrderHistoryResponseItemShuffleMergeCommandRepresentation;
};

export type OrderCargoOrderHistoryResponseItemPerformedCommand =
  | OrderCargoOrderHistoryResponseItemBindPassengerCommand
  | OrderCargoOrderHistoryResponseItemCancelOrderCommand
  | OrderCargoOrderHistoryResponseItemChangeRideCommand
  | OrderCargoOrderHistoryResponseItemChangeTargetTaxiCommand
  | OrderCargoOrderHistoryResponseItemDealerApprovalCommand
  | OrderCargoOrderHistoryResponseItemDispatchApprovalCommand
  | OrderCargoOrderHistoryResponseItemExternalIdUpdateCommand
  | OrderCargoOrderHistoryResponseItemInitializeCommand
  | OrderCargoOrderHistoryResponseItemMergeOrderCommand
  | OrderCargoOrderHistoryResponseItemOperatorApprovalCommand
  | OrderCargoOrderHistoryResponseItemRequestCancelOrderCommand
  | OrderCargoOrderHistoryResponseItemRevertCancelOrderRequestCommand
  | OrderCargoOrderHistoryResponseItemShuffleMergeCommand;

export type OrderCargoOrderHistoryResponseItemAuthor = {
  firstName: string;
  lastName: string;
};

export type OrderCargoOrderHistoryResponseItem = {
  createdAt: string;
  author: OrderCargoOrderHistoryResponseItemAuthor;
  performedCommand: OrderCargoOrderHistoryResponseItemPerformedCommand;
  cargoTaxiBillingModel: OrderCargoOrderHistoryResponseBillingModel | null;
  taxiCorporationDisplayName: string | null;
};

type OrderCargoOrderHistoryResponse = HttpResponse<
  OrderCargoOrderHistoryResponseItem[]
>;

export default OrderCargoOrderHistoryResponse;
